export var TimingFrequency;
(function (TimingFrequency) {
    TimingFrequency["EveryPage"] = "on_every_page";
    TimingFrequency["OncePerVisit"] = "once_per_visit";
    TimingFrequency["OncePerVisitor"] = "once_per_visitor";
    TimingFrequency["OncePerProperty"] = "once_per_property";
    TimingFrequency["OncePerBrand"] = "once_per_brand";
})(TimingFrequency || (TimingFrequency = {}));
//# sourceMappingURL=timing.types.js.map